import { RootRoutes } from '../../../constants';

export const DashboardRoutes = {
	Root: `${RootRoutes.Dashboard}/public`,
};
